import { DsdFile } from "@/types/dsd";
import { useAuth } from "@/contexts/auth-context";
import { popModal, pushModal, useModalStore } from "@/stores/modal";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/styles/ui/dropdown-menu";
import IconButton from "@/toggle-ui-kit/icon-button";
import { EllipsisVertical, SquarePen, Trash2 } from "lucide-react";
import { useState } from "react";
import {
  DeleteProgressModal,
  DSDDeleteModal,
} from "../project-list/delete-modal";
import { RenameDsdModal } from "../project-list/rename-modal";

interface ReportRowMenuProps {
  file: DsdFile;
}

// ============================================
// ReportRowMenu
// 보고서 행의 ⋮ 더보기 메뉴. 이름 변경 · 삭제.
// (즐겨찾기는 행의 별 버튼, 버전 업데이트는 그룹 행의 버튼으로 분리됨.)
// ============================================

export const ReportRowMenu = ({ file }: ReportRowMenuProps) => {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const { push, pop } = useModalStore((state) => state.modals);

  const isOwner = file.creator === user?.email;

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <IconButton
          variant="transparent"
          icon={<EllipsisVertical className="size-4" />}
          onClick={(e) => e.stopPropagation()}
        />
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="w-[180px] p-1 bg-white border border-neutral-200 shadow-md rounded-[12px]"
        onClick={(e) => e.stopPropagation()}
      >
        <DropdownMenuItem
          className="flex items-center gap-2 px-2 py-1.5 outline-none cursor-pointer rounded-md hover:bg-neutral-100"
          onClick={(e) => {
            e.stopPropagation();
            pushModal(RenameDsdModal, { file, onClose: () => popModal() });
            setOpen(false);
          }}
        >
          <SquarePen className="w-4 h-4 text-neutral-500" />
          <span className="label-1-normal-regular text-primary">
            보고서 이름 변경
          </span>
        </DropdownMenuItem>

        <DropdownMenuSeparator className="my-1 h-px bg-neutral-200" />

        <DropdownMenuItem
          disabled={!isOwner}
          className="flex items-center gap-2 px-2 py-1.5 outline-none cursor-pointer rounded-md hover:bg-neutral-100"
          onClick={(e) => {
            e.stopPropagation();
            setOpen(false);
            push(DSDDeleteModal, {
              file,
              onClose: () => pop(),
              onDeleteProgress: () => push(DeleteProgressModal),
            });
          }}
        >
          <Trash2 className="w-4 h-4 text-red-600" />
          <span className="label-1-normal-medium text-red-600">삭제</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
